import {Component} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MmTranslateService} from '../../../../mm-translate.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'mydocma-mm-faults-sync-status-info-popup',
    templateUrl: './mm-faults-sync-status-info-popup.component.html',
    styleUrls: ['./mm-faults-sync-status-info-popup.component.scss'],
    providers: [ { provide: TranslateService, useExisting: MmTranslateService }
    ]
  })
  export class MmFaultsSyncStatusInfoPopupComponent {

    constructor(public dialogRef: MatDialogRef<MmFaultsSyncStatusInfoPopupComponent>) {}

    close() {
      this.dialogRef.close();
    }
}
